$(document).ready(function(){
	
    /*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
    /*						STICKY HEADER						*/
    /*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/

    // Seuil de déclenchement du sticky header
    var sticky_threshold = 300;

    $(window)
	.scroll(function() {
		if ($(window).scrollTop() >= sticky_threshold) {
			$('.headerSite').addClass('sticky');
		} else {
			$('.headerSite').removeClass('sticky');
		}
	})
	.scroll();


	    /*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
    /*						STICKY HEADER						*/
    /*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/

    // Seuil de déclenchement du sticky header
    var sticky_threshold = 300;

    $(window)
	.scroll(function() {
		if ($(window).scrollTop() >= sticky_threshold) {
			$('.headerSite').addClass('sticky');
		} else {
			$('.headerSite').removeClass('sticky');
		}
	})
	.scroll();


	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*							FANCYBOX							*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/	

	$(".fancy, [data-fancybox]").fancybox({
		closeClickOutside : true,
		touch : true,
		loop : true,
		gutter : 30
	});

	
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*					POUR LES LIENS DE PARTAGE				*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	open_popup = function(url){

		mywidth = 500;
		myheight = 350;
		myleft = (screen.width - mywidth) / 2;
		mytop = (screen.height - myheight) / 2;
		window.open( url, 'nouvo', 'width='+mywidth+',height='+myheight+',scrollbars=1,resizable=0,menubar=0,toolbar=0,status=0,location=0,directories=0,left='+myleft+',top='+mytop);
	}


	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*						MENU MOBILE									*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/	
	
	var animEnCours = false;
	var mobileBreakPoint = 1200;

	resetMenu = function(){
		$('.menuSite-bouton').removeClass("active");
		$(".menuSite-interne").removeAttr("style")
		$(".menuSite-interne > ul > li").css("left","0");
		$(".menuSite-retour").remove();

		if(window.innerWidth < mobileBreakPoint){
			$(".menuSite-interne > ul > li ul").css("display","none");
		}else{
			$(".menuSite-interne > ul > li ul").removeAttr("style");
		}
	}

	// ENRICHISSEMENT DU MENU
	$(".menuSite li ul").each(function () {
		// On met la classe parentLink sur les li qui contiennent des sous-ul
		$(this).parent('li').addClass('parentLink');
		// On rajoute la petite fleche qui servira pour naviguer dans les niveaux sur mobile
		$(this).parent('li').children('a').append('<span class="niveauEnfant"></span>');
	});

	//OUVERTURE MENU
	$('.menuSite-bouton').on('click', function(){
		if($(this).hasClass("active")){
			$(this).removeClass('active');
			//On reset le sous menu
			setTimeout(function(){ 
				resetMenu();
			}, 100);
		}else{
			$(this).addClass('active');
		}
	});
	 
	//NAVIGATION DANS LE MENU MOBILE
	$(".menuSite-interne .niveauEnfant").on('click', function () {

		if (window.innerWidth < mobileBreakPoint) {
			if ($(this).closest('li').children('ul').length > 0 && !animEnCours) {
				animEnCours = true;
				$(this).closest('li').children('ul').prepend('<li class="menuSite-retour"><a href="#" title="Retour au menu précédent">Retour</a></li>');
				$(this).closest('li').children('ul').css("display", "block");
				$(".menuSite-interne").stop(true, true).animate({ "left": "-=100%" }, 400, function () {
					animEnCours = false;
				});
				return false;
			} else {
				return true;
			}
		}
	});

	//CLICK FLECHE RETOUR
	$(".menuSite ul li").on("click", ".menuSite-retour", function(){
		var retour = $(this);
		if(!animEnCours){
			animEnCours = true;
			$(".menuSite-interne").stop(true,true).animate({"left":"+=100%"},400, function(){
				retour.parent("ul").css("display","none");
				retour.remove();
				animEnCours = false;
			});
		}
		return false;
	});

	/*
	 * RESIZE MENUS
	 */
	$(window).resize(function(){
		resetMenu();
	});


	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*						DEBUG									*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/

	var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
	var isIE = window.navigator.msPointerEnabled;

	if (isSafari) {
		$('body').addClass('safariUser');
	}
	else if (isIE) {
		$('body').addClass('ieUser');
	}



	/**
	 * Callback sur le clic d'un lien avec la classe keep_post
	 * Lors du clic sur un lien "keep_post" la redirection est annulée, et l'on récupère le data de l'element
	 * avec la classe "filtres", le data "params" doit correspondre a un objet json key->value
	 * Un formulaire sera crée avec les paramètres en temps que input.
	 * Ce formulaire sera ensuite ajouter au dom pour être submit
	 * 
	 * Cette fonction permet globalement d'envoyer des donnée post sur une redirection et est ici utiliser pour conserver les données post
	 * sur une navigation sans avoir a les montré dans le get.
	 */
	$(".keep_post").on('click', function(e){
        e.preventDefault();
        const url = $(this).attr("href");
        const posts = $(".filtres").data("params");
        let inputs;
        Object.keys(posts).forEach(key => {
            inputs =
            `${inputs}
            <input style="display: none;" type="text" name="${key}" value="${posts[key]}" />
            `
        });
		if ($(this).data('id') != undefined) {
			inputs = 
			`${inputs}
			<input style="display: none;" type="text" name="id" value="${$(this).data('id')}" />
			`
		}
		$('.selecteur_affichage > div').each(function(){	
			if ($(this).attr('aria-selected') === "true") {
				inputs = 
				`${inputs}
				<input style="display: none;" type="text" name="type_affichage" value="${$(this).data('type')}" />
				`
			}
		})
        var form = 
        $(`<form action="${url}" method="post">
        ${inputs}
        </form>`);
        $('body').append(form);
        form.submit();
    });


});

